import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import React from "react";
import { toast } from "react-toastify";
import { useLazyGetUserPendingPaymentReportDetailQuery } from "store/services/reportApi";

import { exportExcelFile } from "utils/exportExcelFile";

const ExportUserCODReportExcel = ({ userId, chargeType, paymentStatus }) => {
  const [fetchCODUserReportDetail, { isLoading, isFetching }] =
    useLazyGetUserPendingPaymentReportDetailQuery();

  const handleDownload = async (data) => {
    try {
      const responseData = await fetchCODUserReportDetail({
        userId,
        page: 1,
        limit: 10000,
        ...(paymentStatus && paymentStatus !== "all" && { paymentStatus }),
        ...(chargeType && chargeType !== "all" && { chargeType }),
      }).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        "Responsible User": row.responsibleUser?.name || "N/A",
        "Shipment Id": row.shipmentId || "N/A",
        Charge: row.charge ? Number(row.charge) : 0,
        Status: row.paymentStatus || "N/A",
        Date: row.createdAt
          ? moment(row.createdAt).format("YYYY-MM-DD")
          : "N/A",
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "COD_User_Report",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error("Error fetching COD user report data: " + error.message);
    }
  };

  return (
    <div>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportUserCODReportExcel;
